<template>
  <v-card>
    <v-system-bar color="accent" dark window>
      <v-toolbar-title>{{editMode? 'Редактировать раздел базы знаний' : 'Добавить раздел базы знаний'}}</v-toolbar-title>
    </v-system-bar>
    
    <v-card-text>
      <v-tabs slot="extension" v-model="tab" slider-color="primary" grow color="panel" dark>
        <v-tab href="#params">Параметры</v-tab>
        <v-tab href="#content">Контент</v-tab>
        <v-tab href="#alt_content">Альт. контент</v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item class="mt-2" id="params">
          <v-layout row wrap>
            <v-flex xs12>
              <dantser-tree label="Выберите раздел"
                            :field="true"
                            ref="parentTree"
                            :checkbox="false"
                            :selectMode="1"
                            :source="treedata"
                            @node-dblclick="setSection($event)"
              ></dantser-tree>
            </v-flex>
            <v-flex xs3 sm2 lg1>
              <p class="ma-0 grey--text text--darken-1">Иконка</p>
              <v-menu offset-y right v-model="showIconsMenu">
                <v-btn icon class="mt-0" slot="activator">
                  <v-icon>{{knowledge.icon}}</v-icon>
                </v-btn>
                <v-card style="width: 600px; max-width: 100%;">
                  <v-btn icon v-for="(icon, index) in icons" :key="index" @click="knowledge.icon=icon">
                    <v-icon>{{icon}}</v-icon>
                  </v-btn>
                </v-card>
              </v-menu>
            </v-flex>
            <v-flex xs9 sm10 lg11>
              <v-text-field v-model="knowledge.name" label="Название" hide-details></v-text-field>
            </v-flex>
            <v-flex xs12>
              <p class="mb-0 mt-2">Область видимости</p>
              <dantser-scope :treedata="postsTree" v-model="knowledge.scope" withScopes></dantser-scope>
            </v-flex>
          </v-layout>
        </v-tab-item>
        <v-tab-item class="mt-2" id="content">
          <v-flex xs12 v-for="(block, index) in knowledge.contents" :key="index">
            <dantser-editor v-model="block.data" :init="config" :api-key="apiKey"></dantser-editor>
          </v-flex>
        </v-tab-item>
        <v-tab-item class="mt-2" id="alt_content">
          <v-flex xs12>
            <dantser-editor v-model="knowledge.alternative_content" :init="config" :api-key="apiKey"></dantser-editor>
          </v-flex>
        </v-tab-item>
      </v-tabs-items>
    </v-card-text>
    
    <v-card-actions class="pa-3">
      <v-btn color="success" dark @click="submitData" :disabled="status.btnDisabled">Сохранить</v-btn>
      <span :class="status.className" class="ml-2">{{status.text}}</span>
      <v-spacer></v-spacer>
      <v-btn @click="$emit('close-dialog')" color="error">Отмена</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  import {mapState} from 'vuex'
  import { FileUploadService } from 'v-file-upload'
  
  export default {
    name : 'KnowledgeBaseForm',
    
    props: {
      data: {
        type: Object,
        required: false,
        default: () => {return {
          parent_id: null,
          name: "",
          alternative_content: "",
          icon: "mdi mdi-circle-medium",
          contents: [{type: 0, data: ""}],
          scope: []
        }}
      },
      editMode: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    
    computed:{
      ...mapState('helper', {
        icons: state => state.iconsList,
        config: state => state.editorBaseConfig,
        apiKey: state => state.editorApiKey,
      }),
    },
    
    data() {
      return {
        knowledge: {},
        treedata: [],
        postsTree: [],
        tab: null,
        blockTypes:[
          { value: 0, text: 'Текст'},
         // { value: 1, text: 'Видео'}
        ],
        url: process.env.HELPER_UPLOAD_URL || '/api/private/helper/v1/save-content',
        loadingVideos: {},
        showIconsMenu: false,
        status:{
          btnDisabled: false,
          text: '',
          className:'green--text darken-1'
        }
      }
    },
    
    mounted(){
      this.knowledge = Object.assign({}, this.data)
      if (this.knowledge.contents.length===0) this.addBlock()
      this.getTrees()
    },
    
    methods : {
      getTrees(){
        let id = this.data.id || "all"
        this.$store.dispatch('helper/loadKbTree', id).then( data => {
          this.treedata = data
          this.treedata.unshift({id:null, name: 'Корневой раздел'})
          this.$nextTick(function () {
            this.$refs['parentTree'].setSelected(this.data.parent_id)
          })
        })
        this.$store.dispatch('app/org/tree', 'other').then(usersTree => {
          this.postsTree = usersTree
        })
      },
      
      setSection(node){
        this.knowledge.parent_id = node.id
      },
      
      addBlock(){
        this.knowledge.contents.push({type: 0, data: ""})
      },
      
      deleteBlock(index){
        this.knowledge.contents.splice(index, 1)
      },
      
      submitData(){
        if(this.knowledge.contents[0].data.length === 0){
          this.status={ btnDisabled: false, text: 'Нужно заполнить контент', className:'red--text lighten-1' }
        } else {
          this.status={ btnDisabled: true, text: 'Сохранение', className:'grey--text lighten-1' }
  
          if(this.editMode){
            this.$store.dispatch('helper/updateKbContent', this.knowledge).then( response => {
              this.status={ btnDisabled: false, text: 'Сохранено', className:'green--text darken-1' }
              this.$emit('save', {data: this.knowledge, editMode: true})
            }).catch( error => {
              this.status={ btnDisabled: false, text: 'Ошибка', className:'red--text darken-1' }
            })
          } else {
            this.$store.dispatch('helper/createKbContent', this.knowledge).then( data => {
              this.status={ btnDisabled: false, text: 'Сохранено', className:'green--text darken-1' }
              this.knowledge.id = data.id
              this.knowledge.can_view = true
              this.knowledge.children = []
              this.$emit('save', {data: this.knowledge, editMode: false})
            }).catch( error => {
              this.status={ btnDisabled: false, text: 'Ошибка', className:'red--text darken-1' }
            })
          }
        }
        
      },
    
      onFileChange(e, index) {
        let files = e.target.files || e.dataTransfer.files;
        if (!files.length)
          return;
        this.$set(this.loadingVideos, index, true)
        this.saveFile(files[0], index)
      },
    
      saveFile(file, index) {
        let fileUpload = new FileUploadService(this.url)
        fileUpload.upload(file).then( response => {
          this.knowledge.contents[index].data = response.target.response.location
          this.loadingVideos[index] = false
        })
        .catch( e => {
          this.knowledge.contents[index].data = 'Ошибка загрузки видео'
          this.loadingVideos[index] = false
        })
      },
    },
    
    watch:{
      data(){
        this.knowledge = Object.assign({}, this.data)
        if (this.knowledge.contents.length===0) this.addBlock()
        this.getTrees()
        this.tab = 'params'
      }
    }
  }
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/apps/help/components/KnowledgeBase/Forms/KnowledgeBaseForm.vue